export default [
  {
    label: "Usuario",
    value: "Usuario",
  },
  {
    label: "Administrador",
    value: "Admin",
  },
];
